var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Form = function ($element) {
  this.element = $element;
  this.reset = bind(this.reset, this);

  // Disable dimmabled elements
  $(".js-dimmable").each(function () {
    if ($(this).hasClass("dimmable--dimmabled")) {
      $(this).find("input, select, a, button").prop("disabled", true);
    }
  });

  // Detect if a support is checked
  $(".js-support__input").on("change", function () {
    if ($(".js-support__input").is(":checked")) {
      $(".js-dimmable").removeClass("dimmable--dimmabled");
      // $('.js-dimmable').find('input, select, a, button').prop('disabled', false);
      $(".js-supports-help").addClass("hide");
    } else {
      $(".js-dimmable").addClass("dimmable--dimmabled");
      // $('.js-dimmable').find('input, select, a, button').prop('disabled', true);
    }
  });

  // Prevent double submit
  // this.element.on('submit', function(){
  //     if($("input[name='typeDon']:checked").val() != 2)
  //     {
  //       if (confirm('Êtes-vous certain de vouloir continuer?')) {
  //         $('.js-field').removeAttr('disabled');
  //         $('.js-dimmable').addClass('dimmable--dimmabled');
  //         $('.js-suggestion-free').val($('.js-suggestion-free').val().replace(' ', ''));
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //   });

  //
  $("#ContinueModalContinue").on("click", function () {
    $(".js-field").removeAttr("disabled");
    $(".js-dimmable").addClass("dimmable--dimmabled");
    $(".js-suggestion-free").val(
      $(".js-suggestion-free").val().replace(" ", ""),
    );
    $("#etape1").submit();
    $("#ContinueModal").hide();
  });

  $("#ContinueClick").on("click", function () {
    if ($("input[name='typeDon']:checked").val() == 2) {
      $("input, select").trigger("blur");

      // Submit form if error
      if ($(".input__state--invalid, input--error, label--error").length > 0) {
        $(".js-field").removeAttr("disabled");
        $("#etape1").submit();
      } else {
        // Show confirmation popup if valid
        $("#ContinueModal").css("display", "block");
        $("#ContinueModal").css("opacity", 1);
        $("#ContinueModal").css("visibility", "visible");

        var data = $("#etape1").serializeArray();

        var nom = $('[name="nom"]').val();
        var prenom = $('[name="prenom"]').val();
        var nom_corrige = $('[name="nom_corrige"]').val();
        var prenom_corrige = $('[name="prenom_corrige"]').val();
        var numeroCivique = search("numeroCivique", data).value;
        var adresseType = search("adresseType", data).value;
        var adresseTypeLabel = $(
          '#adresseType option[value="' + adresseType + '"]',
        ).html();
        var adresseTypeSlash = adresseTypeLabel.indexOf("/");
        var adresseTypeFormatted = adresseTypeLabel.substring(
          0,
          adresseTypeSlash - 1,
        );
        var adresse = search("adresse", data).value;
        var remiseType = search("remiseType", data).value;
        var remiseTypeLabel = $(
          '#remiseType option[value="' + remiseType + '"]',
        ).html();
        var remiseTypeSlash = remiseTypeLabel.indexOf("/");
        var remiseTypeFormatted = remiseTypeLabel.substring(
          0,
          remiseTypeSlash - 1,
        );
        var remise = search("remise", data).value;
        var province = search("province", data).value;
        var ville = search("ville", data).value;
        var codepostal = search("codepostal", data).value;
        var telephone = search("telephone", data).value;
        var courriel = search("courriel", data).value;
        var montant = search("montant", data).value;
        var erreur_nom_prenom = $("#erreur_nom_prenom")[0];

        $('[data-placeholder="nom"]').html(
          nom_corrige && erreur_nom_prenom.checked ? nom_corrige : nom,
        );
        $('[data-placeholder="prenom"]').html(
          prenom_corrige && erreur_nom_prenom.checked ? prenom_corrige : prenom,
        );
        $('[data-placeholder="numeroCivique"]').html(
          numeroCivique ? numeroCivique + ", " : "",
        );
        $('[data-placeholder="adresseType"]').html(adresseTypeFormatted);
        $('[data-placeholder="adresse"]').html(adresse ? adresse + ", " : "");
        $('[data-placeholder="remiseType"]').html(remiseTypeFormatted);
        $('[data-placeholder="remise"]').html(remise);
        $('[data-placeholder="province"]').html(
          province ? ", " + province : "",
        );
        $('[data-placeholder="ville"]').html(ville);
        $('[data-placeholder="codepostal"]').html(codepostal);
        $('[data-placeholder="telephone"]').html(telephone);
        $('[data-placeholder="courriel"]').html(courriel);
        $('[data-placeholder="montant"]').html(
          montant ? "Montant : " + montant + "$" : "",
        );
      }
    } else {
      $(".js-field").removeAttr("disabled");
      $("#etape1").submit();
    }
  });
  //

  // Handle the mouseleave event when you click and drag on the button
  $('button[type="submit"]').on("mouseleave", function () {
    $(this).trigger("blur");
  });

  // Disabled field locked on autocomplete
  if ($(".js-nuq").val() != "") {
    $(".js-field-locked-on-autocomplete").each(function () {
      if ($(this).val() != "") {
        $(this).attr("disabled", "disabled");
      }
    });
  }

  // Make the postal code uppercase
  $(".js-postalcode").on("keyup", function () {
    $(this).val(function () {
      return this.value.toUpperCase();
    });
  });

  $(".js-country").on("change", function () {
    if (this.value == "CA") {
      $(".js-postalcode").attr("data-message", "Invalide : format 'B3B 3B3'");
      $(".js-postalcode").attr(
        "data-regex",
        "^[a-zA-Z]\\d[a-zA-Z]\\s*\\d[a-zA-Z]\\d$",
      );
    } else {
      $(".js-postalcode").attr(
        "data-message",
        "Invalide : '94706 ou 99577-0727'",
      );
      $(".js-postalcode").attr("data-regex", "^\\d{5}(-\\d{4})?$");
    }

    $(".js-postalcode").trigger("blur");
  });

  $(".js-nom-prenom-errone").on("change", function () {
    if (this.checked) {
      $(".js-prenom-nom-errone-content").removeClass("hidden");
    } else {
      $(".js-prenom-nom-errone-content").addClass("hidden");
    }
  });

  // Handle steps
  var steps = $(".step");

  $(".js-support__input").on("change", function () {
    var support = parseInt($(".js-support__input:checked").val()),
      totalIndex = 0;

    steps.each(function (index, item) {
      var current = $(item),
        supports = current.data("supports"),
        counter = current.find(".js-step-count");

      if ($.inArray(support, supports) >= 0) {
        totalIndex = totalIndex + 1;
        current.show();
        counter.html(totalIndex);
      } else {
        current.hide();
      }
    });
  });
};

function search(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].name === nameKey) {
      return myArray[i];
    }
  }
}

/* --------------------------------------------
  Reset the form
  @Params: none
  @Returns: none
*/
// Form.prototype.reset = function(e) {
//   e.preventDefault();
//   this.element.find('select, input').val('').prop('checked', false);
// };

module.exports = Form;
